import * as momentTimezone from 'moment-timezone';

export const guessTimezone = () => momentTimezone.tz.guess() || 'America/Los_Angeles';

export const formatDateAndTime = (date: number): String => momentTimezone(new Date(date)).format('dddd, MMMM Do hh:mm A');
